/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getI64Decoder,
  getI64Encoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from "@solana/kit";
import {
  getDataAccessLevelDecoder,
  getDataAccessLevelEncoder,
  getRiskLevelDecoder,
  getRiskLevelEncoder,
  type DataAccessLevel,
  type DataAccessLevelArgs,
  type RiskLevel,
  type RiskLevelArgs,
} from ".";

/** Role metadata for additional information */
export type RoleMetadata = {
  /** Business purpose */
  businessPurpose: string;
  /** Risk level */
  riskLevel: RiskLevel;
  /** Data access level */
  dataAccessLevel: DataAccessLevel;
  /** Compliance requirements */
  complianceRequirements: Array<string>;
  /** Role owner */
  roleOwner: Option<Address>;
  /** Role custodian */
  roleCustodian: Option<Address>;
  /** Review frequency */
  reviewFrequency: bigint;
  /** Last review timestamp */
  lastReview: Option<bigint>;
  /** Next review due */
  nextReview: Option<bigint>;
};

export type RoleMetadataArgs = {
  /** Business purpose */
  businessPurpose: string;
  /** Risk level */
  riskLevel: RiskLevelArgs;
  /** Data access level */
  dataAccessLevel: DataAccessLevelArgs;
  /** Compliance requirements */
  complianceRequirements: Array<string>;
  /** Role owner */
  roleOwner: OptionOrNullable<Address>;
  /** Role custodian */
  roleCustodian: OptionOrNullable<Address>;
  /** Review frequency */
  reviewFrequency: number | bigint;
  /** Last review timestamp */
  lastReview: OptionOrNullable<number | bigint>;
  /** Next review due */
  nextReview: OptionOrNullable<number | bigint>;
};

export function getRoleMetadataEncoder(): Encoder<RoleMetadataArgs> {
  return getStructEncoder([
    [
      "businessPurpose",
      addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder()),
    ],
    ["riskLevel", getRiskLevelEncoder()],
    ["dataAccessLevel", getDataAccessLevelEncoder()],
    [
      "complianceRequirements",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    ["roleOwner", getOptionEncoder(getAddressEncoder())],
    ["roleCustodian", getOptionEncoder(getAddressEncoder())],
    ["reviewFrequency", getI64Encoder()],
    ["lastReview", getOptionEncoder(getI64Encoder())],
    ["nextReview", getOptionEncoder(getI64Encoder())],
  ]);
}

export function getRoleMetadataDecoder(): Decoder<RoleMetadata> {
  return getStructDecoder([
    [
      "businessPurpose",
      addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder()),
    ],
    ["riskLevel", getRiskLevelDecoder()],
    ["dataAccessLevel", getDataAccessLevelDecoder()],
    [
      "complianceRequirements",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    ["roleOwner", getOptionDecoder(getAddressDecoder())],
    ["roleCustodian", getOptionDecoder(getAddressDecoder())],
    ["reviewFrequency", getI64Decoder()],
    ["lastReview", getOptionDecoder(getI64Decoder())],
    ["nextReview", getOptionDecoder(getI64Decoder())],
  ]);
}

export function getRoleMetadataCodec(): Codec<RoleMetadataArgs, RoleMetadata> {
  return combineCodec(getRoleMetadataEncoder(), getRoleMetadataDecoder());
}
